import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@utils/Query";
import { GetUserSettings, NotificationFilters, userApi } from "@queries/User";
import { SystemlogWidgetType } from "@queries/Notifications";
import moment from "moment";

export default function useSetting(orgId: string) {
  const { data, isLoading, refetch } = useQuery<GetUserSettings>(
    [queryKeys("userSetting").getAll(), orgId],
    () => userApi.getSettings(orgId || ""),
    {
      enabled: !!orgId,
      select: (data) => {
        const newData = { ...data };
        if (newData?.dateTime?.mode === "os") {
          newData.dateTime.timezone = moment.tz.guess();
        }
        if (newData.notification) {
          const allowedKeys: string[] = Object.values(SystemlogWidgetType);
          const filteredEventFilter = Object.keys(
            newData.notification.eventFilter
          ).filter((key) => allowedKeys.includes(key));
          newData.notification.eventFilter = filteredEventFilter.reduce(
            (acc, key) => ({
              ...acc,
              [key]:
                newData.notification?.eventFilter[
                  key as keyof NotificationFilters
                ]
            }),
            {}
          ) as NotificationFilters;
        }
        return newData;
      }
    }
  );
  return {
    data,
    isLoading,
    refetch
  };
}
